import React, { useEffect, useState } from "react";
import { getTeamMembers } from "../api/team.api";
import TeamCard from "../components/TeamCard";
import { BrowserRouter as Router, Routes, Route, Link, useParams, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import "../index.css"; 
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap-icons/font/bootstrap-icons.css';

export default function TeamList() {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const data = await getTeamMembers();
        if (mounted) setMembers(data);
      } catch (err) {
        setError("Failed to load team.");
      } finally {
        if (mounted) setLoading(false);
      }
    };
    load();
    return () => { mounted = false; };
  }, []);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;
  if (!members.length) return <p>No team members found.</p>;

  const leadership = members.filter(m => m.category === "leadership");
  const membership = members.filter(m => m.category === "member");

  return (
    <>
    <Helmet>
      <title>LCWE | Team</title>
    </Helmet>
    <div className="container-fluid position-relative p-0">
      <div className="container-fluid py-2" style={{marginBottom:90, backgroundColor:"#15415c"}}>
            <div className="row py-5">
                <div className="col-12 pt-lg-2 mt-lg-2 text-center">
                    <h1 className="display-4 text-white animated zoomIn">LCWE Team</h1>
                    <Link to="/" className="h5 text-white">Home</Link>
                    <i className="bi bi-circle text-white px-2"></i>
                    <Link to='/' className="h5 text-white">Team</Link>
                </div>
            </div>
        </div>
    </div>
    <div className="container-xxl py-5" data-wow-delay="0.1s">
      <div className="container">
          <div className="section-title text-center position-relative pb-3 mb-5 mx-auto" style={{maxWidth:600}}>
              <h5 className="fw-bold text-primary text-uppercase">Leaderships</h5>
              <h2 className="mb-0">Guiding the vision and strategic direction of LCWE</h2>
          </div>
          
          {leadership.map(l => (
            <div key={l.id} className="row g-4 rounded-lg shadow-lg mb-5">
                <div  className="col-lg-4">
                  <h3>{l.name}</h3>
                  <h5>{l.position}</h5>
                </div>
                <div class="col-lg-8 pt-4 pt-lg-0">
                  {l.bio && l.bio.includes("/") ? (
                    l.bio.split("/").map((obj, idx) => (
                      <p key={idx} style={{ textAlign: "justify" }}>
                        {obj.trim()}
                        <br />
                      </p>
                    ))
                  ) : (
                    <p style={{ textAlign: "justify" }}>{l.bio}</p>
                  )}
               </div>
            </div>
          ))}

          <div className="section-title text-center position-relative pb-3 my-5 mx-auto" style={{maxWidth:600}}>
              <h5 className="fw-bold text-primary text-uppercase">Staff</h5>
              <h2 className="mb-0">Supporting the mission and daily operations of LCWE</h2>
          </div>
          <div className="row g-4">
            {membership.map(m => (
              <div className="col-lg-3 col-md-6 rounded-lg shadow-lg" key={m.id}>
                <TeamCard member={m} />
              </div>
            ))}
          </div>
      </div>
    </div>
    </>
  );
}
